<!--
 * @Descripttion: 
 * @Author: liang
 * @Date: 2020-09-11 17:22:16
 * @LastEditors: liang
 * @LastEditTime: 2024-07-03 16:57:50
-->
<template>
  <div>
    <!-- <div id="secondnav">
      <div class="secondnav">
        <div class="title">业务范围</div>
        <div class="nav">
          <a
            :class="{ on: item.dictValue == tid }"
            v-for="(item, index) in navlist"
            @click="changetab(item.dictValue)"
            :key="index"
            >{{ item.dictName }}</a
          >
        </div>
      </div>
    </div> -->
    <div class="main secondulli">
      <div class="nav">
        <div class="title">{{ leftNavName }}</div>
        <a
          :class="{ on: item.dictValue == tid }"
          v-for="(item, index) in navlist"
          @click="changetab(item.dictValue)"
          :key="index"
          >{{ item.dictName }}</a
        >
        <!-- <el-menu
          class="el-menu-vertical-demo"
          default-active="11"
          background-color="rgb(200, 209, 228)"
          text-color="#333"
          active-text-color="#9c1f21"
        >
          <el-submenu index="11">
            <template slot="title">
              <span>招标代理</span>
            </template>
            <el-menu-item
              index="index"
              v-for="(item, index) in tablist"
              :key="index"
              @click="changetabdiv(index)"
              >{{ item.name }}</el-menu-item
            >
          </el-submenu>
          <el-menu-item index="22" @click="changetab(1)">
            <span slot="title">造价咨询</span>
          </el-menu-item>
          <el-menu-item index="33" @click="changetab(2)">
            <span slot="title">工程监理</span>
          </el-menu-item>
        </el-menu> -->
      </div>
      <div class="content">
        <!-- 循环navlist 对应显示内容 -->
        <div class="tabdiv">
          <i class="el-icon-caret-left redsanjiao"></i>
          <ul>
            <li
              v-for="(item, index) in bbtypelist"
              :class="{ on: index == ptype }"
              :key="index"
              @click="changetabdiv(item.dictCode)"
            >
              {{ item.dictName }}
            </li>
          </ul>
          <div class="tablist">
            <!-- 内容 -->
            <div class="innercontent" v-if="ptype == 0 || ptype == 1">
              <div class="article">
                <div class="titlename">
                  <h2>
                    <!-- {{
                      navlist.filter(item => item.dictValue == tid)[0].dictName
                    }} -->
                    {{ info ? info.title : "暂无" }}
                  </h2>
                  <!-- <p>
                    <span>{{ info ? info.title : "暂无" }}</span>
                  </p> -->
                </div>
                <div v-if="info" class="nr" v-html="info.content"></div>
                <div v-else class="nr">暂无</div>
              </div>
            </div>
            <ul v-if="ptype == 2">
              <li
                v-for="(item, index) in datalist"
                @click="toinfo(item.id)"
                :key="index"
              >
                <p>
                  {{ item.name }}
                </p>
                <!-- <span>{{
                  item.createDate ? item.createDate.split(" ")[0] : ""
                }}</span> -->
              </li>
            </ul>
            <div class="search" v-if="ptype == 2">
              <el-input
                placeholder="请输入关键字"
                clearable
                v-model="keyword"
                size="small"
                class="input-with-select"
              >
                <el-button
                  slot="append"
                  size="small"
                  type="primary"
                  icon="el-icon-search"
                  @click="search"
                ></el-button>
              </el-input>
            </div>
            <!-- 内容end -->
          </div>
          <div class="pageno" v-if="ptype == 2">
            <el-pagination
              background
              :current-page="pageno"
              @current-change="handleCurrentChange"
              layout="total, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </div>
          <!-- <div class="search">
            <el-input
              placeholder="请输入关键字"
              v-model="keyword"
              clearable
              size="small"
              class="input-with-select"
            >
              <el-button
                slot="append"
                size="small"
                type="primary"
                icon="el-icon-search"
              ></el-button>
            </el-input>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      keyword: "",
      tid: "",
      pageno: 1,
      ptype: 0,
      datalist: [],
      total: 0,
      tabid: "0",
      navlist: [
        { name: "招标代理" },
        { name: "工程咨询" },
        { name: "造价咨询" },
        { name: "工程监理" }
      ],
      tablist: [],
      bbtypelist: [
        { dictCode: "0", dictName: "服务范围" }
        // { dictCode: "1", dictName: "操作流程" },
        // { dictCode: "2", dictName: "咨询业绩" }
      ],
      info: {},
      leftNavName: ""
    };
  },
  watch: {
    $route: {
      handler() {
        this.tid = this.$route.query.tid;
        this.tabid = this.$route.query.tabid;
        this.pageno = this.$route.query.pageno - 0 || 1;
        this.ptype = this.$route.query.ptype || 0;
        this.keyword = this.$route.query.keyword || "";
        // 二级菜单时，获取companySummaryType
        var nav = JSON.parse(localStorage.getItem("nav"));
        this.leftNavName = nav.filter(item => {
          return item.parent.code === "elseBusiness";
        })[0].parent.name;
        var navlist = nav.filter(item => {
          return item.parent.code === "elseBusiness";
        })[0].child;
        this.navlist = navlist;
        if (this.ptype != 2) {
          this.getinfo();
        } else {
          this.getyj();
        }
      },
      immediate: true
    }
  },
  methods: {
    getinfo() {
      this.$post("/website/getCompanyBusiness", {
        menuCode: "elseBusiness",
        type: this.tid,
        secondtab: this.ptype
      }).then(res => {
        this.info = res.data;
      });
    },
    getyj() {
      this.$get("/website/webperformance/page", {
        menuCode: "elseBusiness",
        businessType: this.tid == 21 ? "1" : "2",
        limit: 10,
        page: this.pageno,
        name: this.keyword
      }).then(res => {
        this.datalist = res.data.list;
        this.total = res.data.total;
      });
    },
    search() {
      this.$router.push({
        path: "/elsebusiness/elsebusiness",
        query: {
          tid: this.tid,
          pageno: 1,
          ptype: this.ptype,
          keyword: this.keyword
        }
      });
    },
    handleCurrentChange(val) {
      this.$router.push({
        path: "/elsebusiness/elsebusiness",
        query: {
          tid: this.tid,
          pageno: val,
          ptype: this.ptype,
          keyword: this.keyword
        }
      });
    },
    changetab(index) {
      this.$router.push({
        path: "/elsebusiness/elsebusiness",
        query: { tid: index, tabid: 0, ptype: 0, pageno: 1 }
      });
    },
    changetabdiv(index) {
      this.ptype = index;
      // this.$router.push({
      //   path: "/elsebusiness/elsebusiness",
      //   query: { tid: this.tid, pageno: 1, ptype: this.ptype }
      // });
    }
  }
};
</script>
<style scoped>
.pageno {
  text-align: right;
  padding-top: 20px;
}
.tablist {
  width: 100%;
}
.tablist ul {
  margin-left: 200px;
  padding-top: 20px;
}
.tablist ul li {
  width: 100%;
  height: 60px;
  display: flex;
  /* cursor: pointer; */
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px dashed #ccc;
}
.tablist li p {
  font-size: 15px;
  flex: 1;
  line-height: 20px;
}
.tablist li span {
  color: #666;
  width: 120px;
  text-align: right;
  font-size: 16px;
}
.tablist li:hover p,
.tablist li:hover span {
  color: #168eca;
}
.search {
  width: 300px;
  position: absolute;
  right: 0;
  top: -10px;
}
.tabdiv {
  position: relative;
}
.tabdiv > ul {
  position: absolute;
  left: -20px;
  top: 36px;
  /* border-bottom: 1px solid rgb(104, 144, 206); */
}
.tabdiv .redsanjiao {
  position: absolute;
  left: -39px;
  top: 42px;
  font-size: 30px;
}
.tabdiv > ul li {
  /* padding: 0 25px;
  display: inline-block;
  border: 1px solid #ddd;
  font-size: 16px; */
  padding: 0 15px;
  display: block;
  width: 170px;
  overflow: hidden;
  background: #fff;
  border-top: none;
  font-size: 14px;
}

/* .tabdiv > ul li.on,
.tabdiv > ul li:hover {
  border: 1px solid rgb(108, 105, 165);
  background: rgb(108, 105, 165);
  cursor: pointer;
  color: #fff;
} */
#secondnav {
  width: 100%;
  background: #fff;
  border-bottom: 1px solid rgb(138, 159, 197);
  box-sizing: border-box;
  height: 80px;
}
.secondnav {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}
/* 下拉导航 */
div /deep/.el-menu-item {
  border-bottom: 1px solid #fff;
  text-align: center;
}
div /deep/.el-menu-item.is-active {
  background: #fff !important;
}
li /deep/.el-submenu__title,
li /deep/.el-submenu.is-active .el-submenu__title {
  border-bottom: 1px solid #fff !important;
  text-align: center;
}
li /deep/.el-menu--inline li {
  border-bottom: 1px dashed #fff;
  background: rgb(217, 221, 230) !important;
}
li /deep/.el-menu--inline li:last-child {
  border-bottom: 1px solid #fff;
}
ul /deep/.el-menu-item:hover {
  background: #fff !important;
  color: #9c1f21 !important;
  background: rgb(183, 197, 226) !important;
}
li /deep/.el-submenu__title:hover {
  background: rgb(183, 197, 226) !important;
}
/* 下拉导航 end*/
.secondnav .title {
  font-weight: bold;
  float: left;
  padding: 0 25px;
  line-height: 75px;
  display: inline-block;
  font-size: 16px;
  border-bottom: 5px solid rgb(30, 69, 141);
  box-sizing: border-box;
}
.secondnav .nav {
  float: right;
  height: 80px;
  display: flex;
  align-items: center;
}
.secondnav .nav a {
  display: inline-block;
  padding: 10px 15px;
  background: rgb(102, 119, 170);
  margin-left: 20px;
  font-size: 16px;
  color: #fff;
}
.secondnav .nav a.on,
.secondnav .nav a:hover {
  background: #9c1f21;
}
.secondnav .mbx {
  float: left;
  padding-top: 33px;
  padding-left: 50px;
}
/* .innercontent {
  padding-top: 20px;
} */

.article {
  background: #fff;
}
.titlename {
  padding: 30px 0;
  border-bottom: 1px dashed #ccc;
}
.nr {
  padding: 20px 60px;
  /* line-height: 42px; */
}
.nr /deep/img {
  max-width: 100%;
}
.titlename h2 {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.titlename p {
  text-align: center;
  padding-top: 10px;
  font-size: 16px;
  color: #999;
}
.titlename p span {
  padding: 10px 0;
}
</style>
